function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import getRoleProperty from '../getRoleProperty';

var ContactRoleNamedInsured = function ContactRoleNamedInsured() {
    var _this = this;

    _classCallCheck(this, ContactRoleNamedInsured);

    this.$onInit = function () {
        var _getRoleProperty = getRoleProperty(_this.roleType, _this.roleModel, 'namedInsured', 'policyAdditionalNamedInsured'),
            fieldValueGetter = _getRoleProperty.fieldValueGetter;

        _this.title = fieldValueGetter(undefined, 'title');
        _this.relationshipToPrimaryNamedINsured = fieldValueGetter(undefined, 'relationshipToPrimaryNamedInsured');
    };
};

export default ContactRoleNamedInsured;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleAdditionalNamedInsured/ContactRoleAdditionalNamedInsuredCtrl.js
// module id = 1640
// module chunks = 0